import type {MutationFunction} from '@apollo/react-common';
import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    setGoogleConflictCalendarSyncIsEnabled as SetGoogleConflictCalendarSyncIsEnabledMutation,
    setGoogleConflictCalendarSyncIsEnabledVariables as SetGoogleConflictCalendarSyncIsEnabledMutationVariables,
} from 'nutshell-graphql-types';

import SET_GOOGLE_CONFLICT_CALENDAR_SYNC_IS_ENABLED from '../mutations/set-google-conflict-calendar-sync-is-enabled.graphql';

export const useSetGoogleConflictCalendarSyncIsEnabled = (): {
    setGoogleConflictCalendarSyncIsEnabled: (isEnabled: boolean) => Promise<any>;
    enableGoogleConflictCalendar: MutationFunction<
        SetGoogleConflictCalendarSyncIsEnabledMutation,
        SetGoogleConflictCalendarSyncIsEnabledMutationVariables
    >;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [setGoogleConflictCalendarSyncIsEnabled, {loading, error}] = useMutation<
        SetGoogleConflictCalendarSyncIsEnabledMutation,
        SetGoogleConflictCalendarSyncIsEnabledMutationVariables
    >(SET_GOOGLE_CONFLICT_CALENDAR_SYNC_IS_ENABLED);

    return {
        setGoogleConflictCalendarSyncIsEnabled: (isEnabled: boolean) =>
            setGoogleConflictCalendarSyncIsEnabled({variables: {isEnabled}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        enableGoogleConflictCalendar: setGoogleConflictCalendarSyncIsEnabled,
    };
};
